export function led(ctx) {
    return {
        styles: {
            main: {
                bg_color:     ctx.accent,
                bg_opa:       255,
                border_width: 2,
                border_color: ctx.accentVar,
                radius:       999,
            },
        },
    };
}
